import { render, staticRenderFns } from "./toolbar-option.vue?vue&type=template&id=61b5545e&"
import script from "./toolbar-option.vue?vue&type=script&lang=js&"
export * from "./toolbar-option.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-option.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports